module.exports = __webpack_public_path__ + "img/fastcharger-realized-private.433eb45d.png";